// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__KYv4u","error":"InputSecondary_error__2Q-rU","disabled":"InputSecondary_disabled__1AWyB"};